import { getBrandFromHost, getLogoFromBrand, isPaxtonBrand } from '@/util/enterprise'
import { AuthContext } from '@/context/auth-context'
import { useContext, useState, useEffect } from 'react'
import { CircularProgressContinuousSized } from './CircularProgressContinuous'

const hostBrand = getBrandFromHost()
const brandLogoUrl = getLogoFromBrand(hostBrand)
const isPaxton = isPaxtonBrand(hostBrand)

type FullPageLoaderProps = {
  statusMessage?: string
}

const FullPageLoader: React.FC<FullPageLoaderProps> = ({ statusMessage }) => {
  const authContext = useContext(AuthContext)
  const { user } = authContext
  const userIsAnon = !(user?.isAnonymous === false)

  // New state and effect to show a message after 20 seconds
  const [showDelayedMessage, setShowDelayedMessage] = useState(false)
  useEffect(() => {
    const timer = setTimeout(() => {
      setShowDelayedMessage(true)
    }, 20000)
    return () => clearTimeout(timer)
  }, [])

  return (
    <div className="flex min-h-full flex-1 flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        {(isPaxton || !userIsAnon) && <img className="mx-auto w-[240px]" src={brandLogoUrl} alt={hostBrand} />}
        <h2 className="mt-6 text-center text-1xl leading-9 tracking-tight text-brand-neutral-900">{statusMessage ? statusMessage : ''}</h2>
        <div className="mt-10 text-center">
          <CircularProgressContinuousSized size={24} thickness={5} />
        </div>
        {showDelayedMessage && (
          <div className="mt-4 text-center text-sm text-gray-500">
            Things are taking a little longer than expected! We are experiencing some hiccups. Please wait a few minutes and then refresh the page.
          </div>
        )}
      </div>
    </div>
  )
}

export default FullPageLoader
